import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useRef } from "react";
import PaginatedList from "../PaginationList";
import useSWR from "swr";


const OrderDetail = ({ expanded }) => {
  // const [lead, setLead] = useState(null);
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const module = "Payments";
  const [selectedRelatedList, setSelectedRelatedList] = useState(null);
  const [calls, setCalls] = useState([])

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);

  const totalPages = Math.ceil(calls.length / recordsPerPage);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentCalls = calls.slice(indexOfFirstRecord, indexOfLastRecord);



  const notesRef = useRef(null);

  const handleRelatedListClick = (name) => {
    setSelectedRelatedList(name);

    if (name === "Notes" && notesRef.current) {
      notesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };



  const idToFetch = id;

  // useEffect(() => {
  //   const fetchLeadData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(`/server/dealer_backend/getSpecificPayment?id=${idToFetch}`); // Replace with actual backend URL
  //       const data = await response.json();
  //       // console.log(data);

  //       if (data.status === "success") {
  //         const filteredLead = data.data.find((item) => item.id === idToFetch);
  //         setLead(data.data[0]);
  //       } else {
  //         // console.error("Error fetching data:", data.error);
  //       }
  //     } catch (error) {
  //       // console.error("Failed to fetch lead data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchLeadData();
  // }, []);



  const fetcher = url => fetch(url).then(res => res.json());

  const { data, isLoading } = useSWR(
    idToFetch ? `/server/dealer_backend/getSpecificPayment?id=${idToFetch}` : null,
    fetcher
  );

  // Extract the lead data once response is loaded and status is success
  const lead = data?.status === "success"
    ? data.data.find(item => item.id === idToFetch) || data.data[0]
    : null;





  const [notesData, setNotesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [emails, setEmails] = useState([]);
  const [payments, setPayments] = useState([]);




  const fetchNotes = async () => {
    try {
      const res = await fetch(`/server/dealer_backend/getNotes?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      if (json.status === "success") {
        const sortedNotes = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
        setNotesData(sortedNotes);
      } else {
        // console.error("Error fetching notes:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };



  const fetchAttachments = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getAttachments?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();



      if (json.status === "success") {
        const sortedAttachments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setAttachments(sortedAttachments);

      } else {
        // console.error("Error fetching attachments:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchStatus = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getStatus?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)

      if (json.status === "success") {
        const sortedStatus = json.data.sort((a, b) => new Date(b.Modified_Time) - new Date(a.Modified_Time));
        setStatusData(sortedStatus);

      } else {
        // console.error("Error fetching status:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchEmails = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getEmails?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedEmails = json.data.sort((a, b) => new Date(b.time) - new Date(a.time));
        setEmails(sortedEmails);

      } else {
        // console.error("Error fetching emails:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchPayments = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getPayments?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedPayments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setPayments(sortedPayments);

      } else {
        console.error("Error fetching payments:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };


  const fetchManualCalls = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getManualCalls?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedCalls = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setCalls(sortedCalls);

      } else {
        console.error("Error fetching payments:", json.error);
      }
    } catch (err) {
      console.error("Network error:", err);
    }
  };

  useEffect(() => {
    fetchNotes();
    // fetchStatus();
    fetchAttachments();
    // fetchEmails();
    // fetchPayments();
    // fetchManualCalls()

  }, [idToFetch])





  const LeadField = ({ label, value, icon }) => (
    <div className="form-group-field2">
      <label>{label}</label>
      <span>
        {icon && <span className="icon">{icon}</span>}
        {value || "—"}
      </span>
    </div>
  );
  const handleEditClick = async () => {
    navigate(`/payment-edit/${idToFetch}`);
  };

  const handleTaskClick = async () => {
    navigate(`/create-task`);
  };


  const formatSize = (bytes) => {
    if (!bytes) return "—";
    const kb = bytes / 1024;
    return kb < 1024
      ? `${kb.toFixed(1)} KB`
      : `${(kb / 1024).toFixed(2)} MB`;
  };




  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };



  const [relatedLists, setRelatedLists] = useState([]);

  // useEffect(() => {
  //   const fetchRelatedLists = async () => {

  //     try {
  //       const response = await fetch(`/server/dealer_backend/getRelatedLists?module=${module}`);
  //       const data = await response.json();
  //       // console.log(data);

  //       if (data.status === "success") {
  //         setRelatedLists(data.related_lists);
  //       } else {
  //         console.error("Failed to fetch transitions:", data.message);
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch related lists:", err);
  //     }
  //   };

  //   fetchRelatedLists();
  // }, [module]);



  const fetcher2 = (url) => fetch(url).then(res => res.json());

  const { data: data2 } = useSWR(
    module ? `/server/dealer_backend/getRelatedLists?module=${module}` : null,
    fetcher2
  );



  useEffect(() => {
    if (data2 && data2.status === "success") {
      setRelatedLists(data2.related_lists);
    }
  }, [data2]);




  return (

    isLoading ? (
      <div className="loading-circle flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    ) : (
      <React.Fragment>
        <header style={{
          position: 'fixed',
          top: 0,
          left: expanded ? '5rem' : '16rem',
          right: 0,
          height: '5rem',
          backgroundColor: 'white',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1rem',
          borderBottom: '1px solid #e5e7eb',
        }} className="header-fixed mobile-header bg-white border-b px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {/* <button className="text-gray-600 hover:text-black text-lg">←</button> */}
            <button
              className="text-gray-600 hover:text-black text-lg"
              onClick={() => navigate('/payments')}  // Go back one step in browser history
              aria-label="Go back"
            >
              <ArrowLeft />
            </button>



            <div className="fl w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
              {lead?.Name.charAt(0).toUpperCase()}
            </div>

            <h1 className="text-xl font-semibold break-words">{lead?.Name}</h1>
          </div>

        </header>
        <div className="flex">
          <aside style={{
            position: 'fixed',
            top: '4rem',
            left: '16rem',
            bottom: 0,
            backgroundColor: 'white',
            padding: '1rem',
            borderRight: '1px solid #e5e7eb',
            overflowY: 'auto',
          }} className="related-list header-fixed  w-64 bg-white border-r p-4 min-h-screen">
            <h3 className="text-lg font-semibold mb-4">Related List</h3>
            <ul className="space-y-2 text-sm text-gray-700">
              {relatedLists.map((item, idx) => (
                <li
                  key={item.id || idx}
                  onClick={() => {
                    setSelectedRelatedList(item.name);
                    if (item.name === "Notes") {
                      window.location.hash = "#notes";
                    } else if (item.name === "Lead Status History") {
                      window.location.hash = "#status";
                    } else if (item.name === "Attachments") {
                      window.location.hash = "#attach";
                    } else if (item.name === "Emails") {
                      window.location.hash = "#email";
                    } else if (item.name === "Manual Call") {
                      window.location.hash = "#call";
                    } else if (item.name === "Payments") {
                      window.location.hash = "#payment";
                    }
                  }}
                  className={`flex justify-between items-center hover:bg-gray-100 px-2 py-1 rounded cursor-pointer ${selectedRelatedList === item.name ? "bg-gray-100 font-medium" : ""
                    }`}
                >
                  <span className="flex items-center gap-1">
                    {item.display_label || item.name}

                    {/* Count badges */}
                    {item.name === "Notes" && notesData.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {notesData.length}
                      </span>
                    )}
                    {item.name === "Attachments" && attachments.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {attachments.length}
                      </span>
                    )}
                    {item.name === "Emails" && emails.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {emails.length}
                      </span>
                    )}
                    {item.name === "Manual Call" && calls.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {calls.length}
                      </span>
                    )}
                    {item.name === "Payments" && payments.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {payments.length}
                      </span>
                    )}
                    {item.name === "Lead Status History" && statusData.length > 0 && (
                      <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                        {statusData.length}
                      </span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </aside>


          <main style={{
            // marginTop: '4rem',
            // marginLeft: '14rem',
            // height: 'calc(100vh - 4rem)',
            // overflowY: 'auto',
            padding: '1rem',
            flexGrow: 1,
          }}>
            <div className="  call-maindiv lead-container p-4 flex-1">
              {/* Lead Status Card */}











              {/* Lead Information Card */}



              <div className="lead-container2">
                <h3 className="lead-title">Payments Information</h3>
                <hr className="lead-divider" />
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                    {/* Left Column */}
                    <div className="space-y-3">
                      <LeadField label="Zoho Payments ID" value={<span className="email-value">{lead?.Name || "—"}</span>} />
                      <LeadField label="Order ID" value={lead?.Order_ID || "—"} />
                      <LeadField label="Tracking ID" value={lead?.Tracking_ID || "—"} />
                      <LeadField label="Bank Reference Number" value={lead?.Bank_Reference_Number || "—"} />
                      <LeadField
                        label="Order Status"
                        value={lead?.Order_Status || "—"} />

                      <LeadField label="Status Message" value={lead?.Status_Message || "—"} />
                      <LeadField
                        label="Email"
                        value={<span className="email-value">{lead?.Email || "—"}</span>}
                      />
                      <LeadField
                        label="Created Time"
                        value={
                          lead?.Created_Time ? (
                            <div>
                              {/* <div>{lead.Created_By}</div> */}
                              <div className="text-gray-500 text-xs mt-1">
                                {new Date(lead.Created_Time).toLocaleString("en-IN", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </div>
                            </div>
                          ) : (
                            "—"
                          )
                        }
                      />
                      <LeadField label="Currency" value={lead?.Currency || "—"} />
                      <LeadField label="Payments Source" value={lead?.Source || "—"} />
                    </div>

                    {/* Right Column */}
                    <div className="space-y-3">
                      <LeadField
                        label="Donor Type"
                        value={
                          lead?.Donor_Type ? (
                            <span
                              className={`inline-block text-white px-3 py-1 rounded-full text-xs${lead.Donor_Type === "Acquisition" ? "bg-green-600" : "bg-yellow-700"
                                }`}
                            >
                              {lead.Donor_Type}
                            </span>
                          ) : (
                            "—"
                          )
                        }
                      />


                      {lead?.Donor_Type === "Acquisition" ? (
                        <LeadField
                          label="Potential Donor"
                          value={
                            lead?.Potential_Donor ? (
                              <a
                                href={`/app/owner-details/${lead.Potential_Donor_Id}`}
                                className="text-blue-600 underline"
                              >
                                {lead.Potential_Donor}
                              </a>
                            ) : (
                              "—"
                            )
                          }
                        />
                      ) : (
                        <LeadField
                          label="Existing Donor"
                          value={
                            lead?.Tagged_Donor ? (
                              <a
                                href={`/app/contact-details/${lead.Tagged_Id}`}
                                className="text-blue-600 underline"
                              >
                                {lead.Tagged_Donor}
                              </a>
                            ) : (
                              "—"
                            )
                          }
                        />
                      )}


                      <LeadField label="Payment Gateway" value={lead?.Payment_Gateway || "—"} />
                      <LeadField label="Payment Frequency" value={lead?.Payment_Frequency || "—"} />
                      <LeadField label="Amount" value={lead?.Amount ? `₹ ${lead.Amount}` : "—"} />
                      <LeadField label="ECI Value" value={lead?.ECI_Value || "—"} />
                      <LeadField
                        label="Transaction Date"
                        value={
                          lead?.Transaction_Date
                            ? new Date(lead.Transaction_Date).toLocaleString("en-IN", {
                              weekday: "short",
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            : "—"
                        }
                      />
                      {/* <LeadField label="Payments Owner" value={lead?.Owner || "—"} /> */}
                      <LeadField
                        label="Modified Time"
                        value={
                          lead?.Modified_Time ? (
                            <div>
                              {/* <div>{lead.Modified_By}</div> */}
                              <div className="text-gray-500 text-xs mt-1">
                                {new Date(lead.Modified_Time).toLocaleString("en-IN", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </div>
                            </div>
                          ) : (
                            "—"
                          )
                        }
                      />
                      <LeadField label="Donation Purpose" value={lead?.Donation_Purpose || "—"} />

                    </div>
                  </div>
                )}

                {/* Billing Details */}
                <h3 className="lead-title mt-6">Billing Details</h3>
                {lead && (
                  <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words mt-4">
                    {/* Left Column */}
                    <div className="space-y-3">
                      <LeadField label="Billing Name" value={lead?.Billing_Name || "—"} />
                      <LeadField label="Billing Phone" value={lead?.Billing_Phone || "—"} />
                      <LeadField label="Billing State" value={lead?.Billing_State || "—"} />
                      <LeadField label="Billing City" value={lead?.Billing_City || "—"} />
                    </div>

                    {/* Right Column */}
                    <div className="space-y-3">
                      <LeadField label="Billing Email" value={lead?.Billing_Email || "—"} />
                      <LeadField label="Billing Zip" value={lead?.Billing_Zip || "—"} />
                      <LeadField label="Billing Country" value={lead?.Billing_Country || "—"} />
                      <LeadField label="Billing Address" value={lead?.Billing_Address || "—"} />
                    </div>
                  </div>
                )}
              </div>






              <div id="notes" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Notes</h3>

                {notesData.length > 0 && (
                  <PaginatedList data={notesData}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange,
                    }) => (
                      <>
                        {/* Table */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">Note</th>
                                <th className="py-2 px-3">Potential Donor</th>
                                <th className="py-2 px-3">Time</th>
                                {/* <th className="py-2 px-3">Owner</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((note, idx) => (
                                <tr key={idx} className="border-t">
                                  <td className="py-2 px-3">{note.Note_Content || "—"}</td>
                                  <td className="py-2 px-3">{note.Parent_Id?.name || "—"}</td>
                                  <td className="py-2 px-3">now</td>
                                  {/* <td className="py-2 px-3">{note.Owner?.name || "—"}</td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination controls */}
                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          {/* Entry range info */}
                          <div>
                            Showing {startEntry} to {endEntry} of {totalRecords} Entries
                          </div>

                          {/* Page size selector */}
                          <div className="flex items-center gap-2">
                            <label htmlFor="notesPageSize">Records per list:</label>
                            <select
                              id="notesPageSize"
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          {/* Pagination buttons */}
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>
                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>)}
              </div>










              <div id="attach" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Attachments</h3>

                {attachments.length > 0 && (
                  <PaginatedList data={attachments}>
                    {({
                      data,
                      currentPage,
                      totalPages,
                      totalRecords,
                      startEntry,
                      endEntry,
                      recordsPerPage,
                      handleChangePage,
                      handlePageSizeChange,
                    }) => (
                      <>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border-collapse">
                            <thead>
                              <tr className="border-b bg-gray-50 text-left">
                                <th className="py-2 px-3">File Name</th>
                                {/* <th className="py-2 px-3">Attached By</th> */}
                                <th className="py-2 px-3">Date Added</th>
                                <th className="py-2 px-3">Size</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((att, idx) => (
                                <tr key={idx} className="border-t">
                                  <td className="py-2 px-3">
                                    {att.File_Name ? (
                                      <a
                                        href="#"
                                        className="text-blue-600 underline cursor-pointer"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          // handleDownload(att.id);
                                        }}
                                      >
                                        {att.File_Name}
                                      </a>
                                    ) : "—"}
                                  </td>
                                  {/* <td className="py-2 px-3">{att.Owner?.name || "—"}</td> */}
                                  <td className="py-2 px-3">{att.Created_Time ? formatDate(att.Created_Time) : "—"}</td>
                                  <td className="py-2 px-3">{formatSize(att.Size)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                          <div>Showing {startEntry} to {endEntry} of {totalRecords} Entries</div>

                          <div className="flex items-center gap-2">
                            <label htmlFor="attachPageSize">Records per list:</label>
                            <select
                              id="attachPageSize"
                              value={recordsPerPage}
                              onChange={handlePageSizeChange}
                              className="border px-2 py-1 rounded"
                            >
                              <option value={5}>5</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                            </select>
                          </div>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleChangePage(currentPage - 1)}
                              disabled={currentPage === 1}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Prev
                            </button>

                            <button
                              onClick={() => handleChangePage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              className="px-3 py-1 border rounded disabled:opacity-50"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </PaginatedList>
                )}
              </div>



              <div id="email" className="lead-container2">
                <h3 className="text-lg font-semibold mb-3">Emails</h3>

                {emails.length > 0 && (<PaginatedList data={emails}>
                  {({
                    data,
                    currentPage,
                    totalPages,
                    totalRecords,
                    startEntry,
                    endEntry,
                    recordsPerPage,
                    handleChangePage,
                    handlePageSizeChange,
                  }) => (
                    <>
                      <div className="overflow-x-auto">
                        <table className="min-w-full text-sm border-collapse">
                          <thead>
                            <tr className="border-b bg-gray-50 text-left">
                              <th className="py-2 px-3">Subject</th>
                              <th className="py-2 px-3">Date</th>
                              <th className="py-2 px-3">Source</th>
                              <th className="py-2 px-3">Sent By</th>
                              <th className="py-2 px-3">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((email, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="py-2 px-3">{email.subject || "—"}</td>
                                <td className="py-2 px-3">{email.time ? formatDate(email.time) : "—"}</td>
                                <td className="py-2 px-3">{email.Source || "—"}</td>
                                <td className="py-2 px-3">{email.from?.user_name || "—"}</td>
                                <td className="py-2 px-3">{email.status?.[0]?.type || "—"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                        <div>
                          Showing {startEntry} to {endEntry} of {totalRecords} Entries
                        </div>

                        <div className="flex items-center gap-2">
                          <label htmlFor="emailPageSize">Records per list:</label>
                          <select
                            id="emailPageSize"
                            value={recordsPerPage}
                            onChange={handlePageSizeChange}
                            className="border px-2 py-1 rounded"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                          </select>
                        </div>

                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleChangePage(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Prev
                          </button>

                          <button
                            onClick={() => handleChangePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </PaginatedList>
                )}
              </div>









            </div>
          </main>

        </div>
      </React.Fragment>
    )


  );
};

export default OrderDetail;
